import {
  createRootRouteWithContext,
  Outlet,
  useRouterState,
} from "@tanstack/react-router"
import { useEffect } from "react"
import { NotFound } from "@/components/not-found"
import { ErrorPage } from "@/components/error-page"
import { initAnalytics, posthog } from "@/lib/posthog"
import type { UserFlags } from "@yomimono/types"

initAnalytics()

interface RouterContext {
  userFlags: UserFlags | undefined
}

function RootComponent() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  useEffect(() => {
    posthog.capture("$pageview", { $current_url: window.location.href })
  }, [pathname])

  return <Outlet />
}

export const Route = createRootRouteWithContext<RouterContext>()({
  notFoundComponent: NotFound,
  errorComponent: ErrorPage,
  component: RootComponent,
})
